import { render } from "./Post.vue?vue&type=template&id=66124414"
import script from "./Post.vue?vue&type=script&lang=js"
export * from "./Post.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Post.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66124414"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66124414', __exports__)) {
    api.reload('66124414', __exports__)
  }
  
  module.hot.accept("./Post.vue?vue&type=template&id=66124414", () => {
    api.rerender('66124414', render)
  })

}


export default __exports__